export const environment = {
  production: true,
  apiUrl: "https://dopa.marinedeep.com/api",
  sentryUrl:
    "https://0c21bc0c2520432081209a21fed39223@o1304986.ingest.sentry.io/6546029",
};
